import { Map as map } from 'immutable';
const C = require("../constants");

function ModalIngredientStockReducer(state = map(), action) {
    switch (action.type) {
        case C.INGREDIENT_STOCK_UPDATE_MODAL:
            return action.modal;
        default:
            return state;
    }
}

export default ModalIngredientStockReducer;


// WEBPACK FOOTER //
// ./src/reducers/ModalIngredientStockUpdateReducer.js